// TODO: decision - switch to NgCore consts in future roadmap [future release]

// AU
export const AU_GST_COMMENCED = new Date(2000, 6, 1); // 1st Jul 2000

// NZ
export const NZ_GST_COMMENCED = new Date(1986, 9, 1); // 1st Oct 1986
